import React, { useEffect, useState } from "react";
import { BsTwitter } from "react-icons/bs";
import { FaFacebookF, FaInstagram, FaYoutube } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import Selectors from "../../../components/selectors/Selectors";
import Spacer from "../../../components/spacer/Spacer";
import LeagueTab from "../../../components/tabs/LeagueTab";
import { Flexed } from "../../Login";
import CreateLeague from "./createleague/CreateLeague";
import LeagueRules from "./createleague/LeagueRules";
import JoinLeague from "./joinleague/JoinLeague";
import LeaguePaths from "./paths/LeaguePaths";
import { toast } from "react-toast";
import AllLeagues from "./paths/AllLeagues";
import Logo from "../../../components/Logo/Logo";

const Wrapper = styled.div`
  position: relative;
  padding: 0rem;
  width: -webkit-fill-available;
  min-width: 380px;

  @media (min-width: 768px) {
    display: grid;
    place-items: center;
    padding: 2rem 2rem 0 2rem;
  }
  h2 {
    color: white;
  }

  .footing {
    max-width: 1000px;
    overflow-x: hidden;
    min-width: 380px;

    @media (max-width: 768px) {
      padding: 1vh 0;
    }
  }

  .b-holding {
    position: fixed;
    display: flex;
    justify-content: center;
    bottom: 4%;
    left: 50%;
    transform: translate(-50%, 50%);
    background: #1c2127;
    width: 100%;

    @media (max-width: 768px) {
      bottom: 5%;
    }
  }
`;

export const Curved = styled.div`
  position: relative;
  display: flex;
  background: hsl(224deg 29.41% 10% / 55%);
  justify-content: center;
  padding: 1rem 1.5rem 2rem 1.5rem;
  width: 550px;

  @media (max-width: 768px) {
    margin: 0 0.5rem;
    width: unset;
  }

  .hold {
    margin-top: 1rem;
    width: 100%;
  }
`;

const ExCurved = styled.div`
  position: relative;
  display: flex;
  background: hsl(224deg 29.41% 10% / 55%);
  justify-content: center;
  padding: 1rem 1.5rem 2rem 1.5rem;
  width: 550px;

  @media (max-width: 768px) {
    margin: 0 0.5rem;
    width: unset;
  }

  .hold {
    position: relative;
    margin: 1rem 1rem 0 1rem;
    width: 100%;
  }
`;

const AppWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  padding: 0 0.5rem;
`;

const LeagueWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
`;

function Leagues() {
  const navigate = useNavigate();
  const [league, setLeague] = useState(true);
  const [rules, setRules] = useState(false);
  const [currentTab, setCurrentTab] = useState(0);
  const [country, setCountry] = useState(null);
  const [createData, setCreateData] = useState(null);
  const token = localStorage.getItem("PRivalsToken");

  useEffect(() => {
    if (!token) {
      toast.error("Access Denied, Kindly Login to get access");
      navigate("/");
    }
  }, []);

  const getRules = (data) => {
    setRules(data);
  };

  const getCurrent = (data) => {
    setCurrentTab(data);
  };

  const getCountry = (data) => {
    setCountry(data);
  };

  const getData = (data) => {
    setCreateData(data);
  };

  return (
    <Wrapper>
      <div className="inner-wrapper">
        <Spacer height="0rem" />
        <Logo />
        <Spacer height="0.2rem" />
        {!rules ? (
          <Curved>
            <div className="hold">
              <Spacer height="0.1rem" />
              <LeagueWrapper>
                <LeagueTab
                  current={currentTab}
                  fTitle="Leagues"
                  sTitle="Join League"
                  tTitle="Create League"
                  fContent={<AllLeagues getCurrent={getCurrent} />}
                  sContent={
                    <JoinLeague fTitle="League Code" sTitle="Search League" />
                  }
                  tContent={
                    <CreateLeague
                      getRules={getRules}
                      type="League"
                      getCurrent={getCurrent}
                      getCountry={getCountry}
                      getData={getData}
                    />
                  }
                  league={league}
                />
              </LeagueWrapper>
            </div>
          </Curved>
        ) : (
          <ExCurved>
            <div className="hold">
              <LeagueRules
                type="League"
                country={country}
                getRules={getRules}
                data={createData}
              />
            </div>
          </ExCurved>
        )}
        <Spacer height="10rem" />
      </div>
      <div className="b-holding">
        <div className="footing">
          <Selectors />
          {/* <Flexed>
            <FaFacebookF className="grey" />
            <FaInstagram className="grey" />
            <BsTwitter className="grey" />
            <FaYoutube className="grey" />
          </Flexed> */}
        </div>
      </div>
    </Wrapper>
  );
}

export default Leagues;
